import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyle: CSSProperties = {
  width: '100%',
  height: '150px',
  position: 'relative',
  overflow: 'hidden',
  background: UIConfig.Colors.BackgroundDark,
  zIndex: 1
};

export const bannerWrapper: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const bannerContainer: CSSProperties = {
  borderRadius: '20px',
  height: '90px',
  marginTop: '10px',
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  alignItems: 'center',
  position: 'relative',
  width: '100%'
};

export const iconWrapper: CSSProperties = {
  width: '100px',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex'
};

export const textContainer: CSSProperties = {
  width: 'calc(100% - 100px - 110px)',
  marginLeft: '3px'
};

export const titleStyle: CSSProperties = {
  textAlign: 'left',
  padding: 0,
  margin: 0,
  fontWeight: 'bold',
  fontSize: '19px',
  color: '#FFF'
};

export const iconContainer: CSSProperties = {
  width: '70px',
  height: '70px',
  background: UIConfig.Colors.PrimaryGradient,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50px',
  marginLeft: '5px'
};

export const subTextContainer: CSSProperties = {
  fontSize: '14px',
  marginTop: '4px',
  color: '#A3A3A3'
};

export const buttonWrapper: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '110px',
  marginRight: '20px'
};
